export const ARROW_ICON = 'https://acko-cms.ackoassets.com/arrow_right_13c606291c.svg'

export const redirectUrl = 'https://www.acko.com/gi/new-car/vehicle-details'
export const redirectUrlWithVehicleId = (id: string) => `${redirectUrl}?vehicle_id=${id}`

export const CAR_COMPARISON_WIDGET_ID = 'car-comparison-widget'

export const notListed = {
  icon: 'https://acko-cms.ackoassets.com/Unable_to_process_a25fc98eec.svg',
  title: 'Car not listed here?',
  subTitle: 'Share your car details to get an instant quote',
  cta: 'Get a quote',
}

export const cardData = {
  cta: 'Get quote',
  dealers: 'Dealer price',
  acko: 'ACKO price',
  savesLeft: 'You save up to ',
  savesRight: ' with ACKO',
}

export const commonEvents = {
  product: 'new_car_comparison',
  funnel: 'entry',
  page_type: 'new_car_comparison',
}
